module.exports = __webpack_public_path__ + "img/s2-1.2e75b8f5.jpg";